import { http } from "../_helpers";
import { config } from "../env";
export const getWorkflowListBasedOnType = (search, page,limit,type,isChecked) =>{
    return http
    .get(`${config.apiExpense}v2.0/workflow/process?search=${search}&page=${page}&limit=${limit}&type=${type}&myPendingApproval=${isChecked}`)
    .then(data => {
      return data ? data : "";
    });
}
